module.exports = __webpack_public_path__ + "static/img/injury01.b80d597.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/Buy/Injury/injury01.jpg
// module id = Zvcv
// module chunks = 12